/* global document */
import React from 'react';
import ReactDOM from 'react-dom';
import $ from 'jquery';
import EmbryoDetail from '../../Api/ApiEmbryoDetail/ApiEmbryoDetail';

let currentModal = null;
let currentReactRoot = null;


function closeEmbryoModal(modal, reactRoot) {
	ReactDOM.unmountComponentAtNode(reactRoot);
	modal.remove();
}


function createEmbryoModal(id, features = null, frame = null) {
	if (currentModal !== null && currentReactRoot !== null && currentReactRoot.length > 0) {
		closeEmbryoModal(currentModal, currentReactRoot[0]);
	}

	const reactRoot = $('<div />');
	const modal = $('<div class="modal-emb-detail" />').append(
		reactRoot,
	);

	const initialFeatures = Array.isArray(features) ? features.reduce((acc, key) => ({
		...acc,
		[key]: true,
	}), {}) : undefined;

	const initialFrame = typeof frame === 'number' ? frame : undefined;

	const close = () => {
		closeEmbryoModal(modal, reactRoot[0]);
	};

	ReactDOM.render(
		<EmbryoDetail
			id={id}
			onLoad={() => $('body').append(modal)}
			initialFeatures={initialFeatures}
			initialFrame={initialFrame}
			onCloseClick={close}
		/>,
		reactRoot[0],
	);

	currentModal = modal;
	currentReactRoot = reactRoot;
}


$(document).on('click', 'a[data-embryo-id]', function embryoLinkClick(e) {
	const id = +$(this).data('embryoId') || null;
	if (id === null) {
		return;
	}

	const features = typeof $(this).data('embryoFeatures') === 'string'
		? $(this).data('embryoFeatures').split(',').filter(Boolean)
		: null;

	const frame = +$(this).data('frame') || null;

	createEmbryoModal(id, features, frame);
	e.preventDefault();
});



// WEBPACK FOOTER //
// ./frontend/components/Embryo/EmbryoModal/EmbryoModal.js